import styled from "styled-components";

export const SDecisionList = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 1.2rem;
	@media (min-width: 768px) {
		gap: 2.4rem;
	}
	@media (min-width: 1920px) {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
	}
	> div {
		flex-grow: 1;
		@media (min-width: 576px) {
			max-width: calc(100% / 2 - 1.2rem / 2);
		}
		@media (min-width: 768px) {
			max-width: calc(100% / 2 - 2.4rem / 2);
		}
		@media (min-width: 1366px) {
			max-width: calc(100% / 3 - 2.4rem / 3);
		}
		@media (min-width: 1920px) {
			max-width: none;
			width: 100%;
		}
	}
`;
